import { Navigate } from 'react-router-dom';
import './SuccessfulPayment.css';
import { useContext, useEffect } from 'react';
import { getCookieWithShop, setCookieWithShop } from '../../assets/utils/utils';
import { CartContext } from '../../assets/contexts/cartContext';
import { ConfigContext } from '../../assets/contexts/configContext';

function SuccessfulPayment() {
    const cart_context = useContext(CartContext)
    const config = useContext(ConfigContext)
    const { initialConstants } = config
    const { SHOP_ID_FOR_API, SHOP_NAME, CONSTANTS, DELIVERIES } = initialConstants
    const cartLocalStorageKey = `cart_${SHOP_ID_FOR_API}`;
    const {
        cart,
        handleAddToCart,
        handleRemoveFromCart,
        setCart,
    } = cart_context
    useEffect(() => {
        const cartPrevArray = cart;
        // setCreatedOrder(order);
        // setPopups((prevValue) => ({
        //     ...prevValue,
        //     order_created: true,
        // }));

        const timestamp = Date.now() + Math.random().toString().slice(2, 11);
        setCookieWithShop('cart_uid_', SHOP_ID_FOR_API, timestamp, 365);
        // setCartUID(getCookieWithShop('cart_uid_', SHOP_ID_FOR_API))

        setTimeout(() => {
            let cartArray = [];
            setCart(cartArray);
            localStorage.removeItem(cartLocalStorageKey);
        }, 500);


        // sendMetriс("reachGoal", "CREATE_ORDER_2");
        // window.dataLayer.push({
        //     ecommerce: {
        //         currencyCode: "USD",
        //         purchase: {
        //             products: cartPrevArray.map((product, i) => {
        //                 console.log({ product })
        //                 return {
        //                     id: product?._id,
        //                     name: `${product?.name} ${product?._id}`,
        //                     //   category: res
        //                     //     ? `${res.category.name}/${res.sub_category.title.ru}`
        //                     //     : "",
        //                     price: getFinalPrice(product.options && product.options.length === 1 ? {
        //                         price: product.options[0].price,
        //                         ...product.price_data,
        //                     } : product.price_data, promo),
        //                     quantity: product.count,
        //                     // variant: product.selected_size ? product.selected_size.name : 'Без размера'
        //                     options: product.options,
        //                 };
        //             }),
        //             actionField: {
        //                 id: `№${("00000000" + order.ai_id).slice(-8)}`,
        //                 goal_id: 301991107,
        //             },
        //         },
        //     },
        // });
        // searchParams.delete("order");
        // searchParams.delete("paid");
        // setSearchParams(searchParams);
    }, [])
    return (
        <Navigate to={'/'} />
    );
}

export default SuccessfulPayment